import type { Tutorial, TutorialCategory, TutorialPlatform } from './types'
import { wellnessCoachTutorial } from './mobile/wellness-coach'
import { wellnessGoalsTutorial } from './mobile/wellness-goals'
import { healthRecordsTutorial } from './mobile/health-records'
import { profileSharingTutorial } from './mobile/profile-sharing'
import { accountabilityPartnersTutorial } from './mobile/accountability-partners'
import { coachCopilotTutorial } from './mobile/coach-copilot'
import { collaboratorMessagingTutorial } from './mobile/collaborator-messaging'
import { multiProfileTutorial } from './mobile/multi-profile'
import { onboardingTutorial } from './mobile/onboarding'
import { wellnessCoachWebTutorial } from './web/wellness-coach'
import { wellnessGoalsWebTutorial } from './web/wellness-goals'
import { healthRecordsWebTutorial } from './web/health-records'
import { profileSharingWebTutorial } from './web/profile-sharing'
import { multiProfileWebTutorial } from './web/multi-profile'
import { collaboratorMessagingWebTutorial } from './web/collaborator-messaging'
import { accountabilityPartnerWorkflowWebTutorial } from './web/accountability-partner-workflow'

export const MOBILE_TUTORIALS: Tutorial[] = [
  wellnessCoachTutorial,
  wellnessGoalsTutorial,
  healthRecordsTutorial,
  profileSharingTutorial,
  accountabilityPartnersTutorial,
  coachCopilotTutorial,
  collaboratorMessagingTutorial,
  multiProfileTutorial,
  onboardingTutorial,
]

export const WEB_TUTORIALS: Tutorial[] = [
  wellnessCoachWebTutorial,
  wellnessGoalsWebTutorial,
  healthRecordsWebTutorial,
  profileSharingWebTutorial,
  multiProfileWebTutorial,
  collaboratorMessagingWebTutorial,
  accountabilityPartnerWorkflowWebTutorial,
]

export const TUTORIALS: Tutorial[] = [...WEB_TUTORIALS, ...MOBILE_TUTORIALS]

export function getTutorialBySlug(slug: string, platform: TutorialPlatform): Tutorial | undefined {
  const list = platform === 'web' ? WEB_TUTORIALS : MOBILE_TUTORIALS
  return list.find((t) => t.slug === slug)
}

export function getTutorialsForPlatform(platform: TutorialPlatform): Tutorial[] {
  return platform === 'web' ? WEB_TUTORIALS : MOBILE_TUTORIALS
}

export function getAllTutorialCategories(platform?: TutorialPlatform): TutorialCategory[] {
  const list = platform ? getTutorialsForPlatform(platform) : TUTORIALS
  const seen = new Set<TutorialCategory>()
  for (const t of list) seen.add(t.category)
  const order: TutorialCategory[] = ['Core Features', 'Sharing & Support', 'Account']
  return order.filter((c) => seen.has(c))
}

export function getTutorialsByCategory(category: TutorialCategory, platform: TutorialPlatform): Tutorial[] {
  return getTutorialsForPlatform(platform).filter((t) => t.category === category)
}

export function tutorialPath(platform: TutorialPlatform, slug: string): string {
  return `/tutorials/${platform}/${slug}`
}

export type { Tutorial, TutorialCategory, TutorialPlatform, TutorialSection } from './types'
